
import { defineComponent, PropType } from 'vue'
import NavbarItemContent from './NavbarItemContent.vue'

export default defineComponent({
  name: 'Action',
  components: {
    NavbarItemContent
  },
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    },
    action: {
      type: String,
      required: true
    },
    payloads: {
      type: Object as PropType<{ [key: string]: unknown }>,
      required: false
    }
  },
  setup () {
    return {}
  }
})
